import { render, staticRenderFns } from "./ShowMaterialBankFiles.vue?vue&type=template&id=266512f3&"
import script from "./ShowMaterialBankFiles.vue?vue&type=script&lang=js&"
export * from "./ShowMaterialBankFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports